import { createContext, useContext, useState, useCallback } from "react";
import { opportunitiesData as initialData } from "@/data/opportunities";

const OpportunityContext = createContext(null);

export function OpportunityProvider({ children }) {
  const [opportunities, setOpportunities] = useState(initialData);

  // Update a single opportunity's recommendation
  const updateRecommendation = useCallback((id, newRecommendation) => {
    setOpportunities(prev =>
      prev.map(opp =>
        opp.id === id ? { ...opp, recommendation: newRecommendation } : opp
      )
    );
  }, []);

  // Update a single opportunity's notes (stored in memory for this session)
  const [notes, setNotes] = useState({});
  
  const updateNotes = useCallback((id, newNotes) => {
    setNotes(prev => ({
      ...prev,
      [id]: newNotes
    }));
  }, []);

  const getNotes = useCallback((id) => {
    return notes[id] || "";
  }, [notes]);

  // Get a single opportunity by ID
  const getOpportunity = useCallback((id) => {
    return opportunities.find(opp => opp.id === id);
  }, [opportunities]);

  const value = {
    opportunities,
    updateRecommendation,
    updateNotes,
    getNotes,
    getOpportunity,
  };

  return (
    <OpportunityContext.Provider value={value}>
      {children}
    </OpportunityContext.Provider>
  );
}

export function useOpportunities() {
  const context = useContext(OpportunityContext);
  if (!context) {
    throw new Error("useOpportunities must be used within an OpportunityProvider");
  }
  return context;
}
